import React from "react";
import { Navigate, useLocation } from "react-router-dom";

const Passwordreset = () => {
  const location = useLocation();

  return (
    <Navigate
      to="/auth-signin-basic"
      replace
      state={{
        ...(location.state || {}),
        forgotPassword: true,
      }}
    />
  );
};

export default Passwordreset;
